export default __webpack_public_path__ + "img/eyeView.44e58fae.svg";